const getCustomHeaderFromLocalstorage = (customHeaders) => {
  let tempObj = {};
  let tempArr = [];
  customHeaders &&
    JSON.parse(customHeaders).forEach((element) => {
      tempObj[element.headerKey] = element.headerValue;
      tempArr.push(tempObj);
      tempObj = {};
    });
  Object.assign(tempObj, ...tempArr);
  return tempObj;
};

export default getCustomHeaderFromLocalstorage;
